import { render, staticRenderFns } from "./getewayRealInfo.vue?vue&type=template&id=81d98ef4&scoped=true&"
import script from "./getewayRealInfo.vue?vue&type=script&lang=js&"
export * from "./getewayRealInfo.vue?vue&type=script&lang=js&"
import style0 from "./getewayRealInfo.vue?vue&type=style&index=0&id=81d98ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d98ef4",
  null
  
)

export default component.exports